import { Controller } from "@hotwired/stimulus"

// Fades content up on first scroll into view. All hiding happens here in JS,
// so content stays visible if JS never runs. Reduced motion opts out entirely.
export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } }

  connect() {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reduced || !("IntersectionObserver" in window)) return

    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(16px)"

    this.observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        this.observer.disconnect()
        this.element.style.transition =
          `opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1) ${this.delayValue}ms, ` +
          `transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) ${this.delayValue}ms`
        this.element.style.opacity = "1"
        this.element.style.transform = "none"
      }
    }, { threshold: 0.12 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.style.opacity = ""
    this.element.style.transform = ""
    this.element.style.transition = ""
  }
}
